import { FC, ReactElement } from 'react';
import { DEBOUNCE_TIME } from 'src/constants/main';
import SearchInput from 'src/view/components/Controls/SearchInput/SearchInput';

interface IProps {
  loading: boolean;
  searchValue: string;
  onSearch: (value: string) => void;
}

export const BranchesModalHeaderSearch: FC<IProps> = (props: IProps): ReactElement => {
  return (
    <SearchInput
      value={props.searchValue}
      onChangeText={props.onSearch}
      loading={props.loading}
      debounceDelay={DEBOUNCE_TIME.MEDIUM}
      customPlaceholder
      placeholder="txt_search"
      withResetIcon
      className="custom-modal-header__search"
      inputClassName="custom-modal-header__search-input"
    />
  );
};
